import { ACCEPTED_IMAGES_FORMAT_IN_OPTIMIZATING_CDN } from "../constants/ExlyImage.constants";

export const isImageTypeValidForOptimization = (
  imageType: string = "",
): boolean => ACCEPTED_IMAGES_FORMAT_IN_OPTIMIZATING_CDN.includes(imageType);
